<template>
  <div
    class="batch-card-source"
    :class="{'batch-card-source--show-bar': display}"
  >
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'BatchCardSource',
  props: {
    text: String
  },
  data: () => ({
    display: false,
    MILISECONDS_TO_SHOW: 1000,
    MILISECONDS_TO_HIDE: 3000
  }),
  mounted () {
    this.playInitialAnimation()
  },
  methods: {
    showHide ({show, miliseconds}) {
      return new Promise(resolve => {
        setTimeout(() => {
          this.display = show
          resolve()
        }, miliseconds)
      })
    },
    async playInitialAnimation () {
      await this.showHide({show: true, miliseconds: this.MILISECONDS_TO_SHOW})
      this.showHide({show: false, miliseconds: this.MILISECONDS_TO_HIDE})
    }
  }
}
</script>

<style lang="scss" scoped>
$minimified-height: 7px;
$maximed-height: 34px;
$vertical-padding: 11px;
$horizontal-padding: 15px;

@mixin hide-bar {
  height: $minimified-height;
  transform: translateY(-calc(#{$vertical-padding} + #{$minimified-height}))
    translateX(-$horizontal-padding);

  span {
    opacity: 0;
    transition: display 0.3s, opacity 0.3s;
    display: none;
  }
}

@mixin show-bar {
  height: $maximed-height;
  transform: translateY(-calc(#{$vertical-padding} + #{$maximed-height}))
    translateX(-$horizontal-padding);

  span {
    opacity: 1;
    padding: 10px;
    display: block;
  }
}

.batch-card-source {
  @include hide-bar;
  background: #7f1a54;
  width: 100%;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: help;
  position: absolute;
  transition: transform 1s, height 1s;

  span {
    color: white;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    letter-spacing: 1.62px;
    text-transform: uppercase;
  }

  &--show-bar {
    @include show-bar;
  }
}
</style>
